import React from 'react'
import styles from './PlaceHolder.module.css'
export const PlaceHolder: React.FC = () => {
  return (
    <div className={styles.reportPlaceholder}>~ 多多滑动，明天就会收到自己的专属日报哦 ~</div>
  )
}